<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb" style="padding-top: 20px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          {{ $t("app.modules.orders.title") }}
        </el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
      </el-breadcrumb>
      <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
    </div>
    <el-divider></el-divider>

    <div class="col-md-12">
      <div class="col-12">
      <!--<h3>
        {{ $t("app.modules.orders.title") }}
      </h3>
      <el-collapse accordion>
            <el-collapse-item
              name="1"
              :title="$t('app.modules.orders.headers.search_order')"
              class="col-12"
            >

              <div class="row">

                <div :class="sizes">
                  {{ $t("app.modules.orders.headers.created_date") }}
                  <el-date-picker
                    v-model="dates_created"
                    type="daterange"
                    align="right"
                    :start-placeholder="$t('app.general.start_date')"
                    :end-placeholder="$t('app.general.end_date')"
                  >
                  </el-date-picker>
                </div>

                <div :class="sizes">
                  {{ $t("app.modules.orders.headers.order_number") }}
                  <fg-input>
                    <el-input
                      type="search"
                      clearable
                      style="width: 300px"
                      :placeholder='
                        $t("app.modules.orders.headers.order_number")
                      '
                      v-model="numer_pedido"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </fg-input>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>-->
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane :label='$t("app.modules.orders.headers.active_orders")' name="first">
      <div class="col-12">
      <mis-pedidos-activos :pedidos="queriedData" />
      </div>
    </el-tab-pane>
    <el-tab-pane :label='$t("app.modules.orders.headers.shopping_history")' name="second">
      <div class="col-12">
      <mi-historial-pedido :pedidos="queriedData"/>
      </div>
    </el-tab-pane>
  </el-tabs>
    </div>
    <partida-docs />
    <nueva-reclamacion />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import NuevaReclamacion from '../components/nuevaReclamacion.vue';
export default {
  components: {
    MisPedidosActivos: () => import("../components/mispedidosActivos"),
    MiHistorialPedido: () => import("../components/historialPedidos"),
    PartidaDocs: () => import("../components/partidaDocs"),
    NuevaReclamacion: () => import("../components/nuevaReclamacion")
  },
  watch: {
  },
  computed: {
    queriedData() {
      let result = this.applyFilters(this.pedidos);
      return result.slice(this.from, this.to);
    },
  },
  data() {
      return {
            sizes: "col-md-3 col-sm-6",
            dates_created: "",
            numer_pedido: "",
          activeName: 'first',
          pedidos: []
      }
  },
  created() {
      this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.getOrders();

    this.$swal.close();
  },
  methods: {
    applyFilters(result) {
      // Busqueda por vendedor
      result =
        this.numer_pedido.length > 0
          ? result.filter(p =>
              p.numPedidoSAP.toLowerCase().includes(this.numer_pedido.toLowerCase())
            )
          : result;

      result =
        (this.dates_created) && this.dates_created[0] > new Date("1900-01-01") &&
        this.dates_created[1] > new Date("1900-01-01") &&
        this.dates_created[0] instanceof Date &&
        this.dates_created[1] instanceof Date
          ? (result = result.filter(
              d =>
                new Date(d.fechaCreacionPedido) >= this.dates_created[0] &&
                new Date(d.fechaCreacionPedido) <= this.dates_created[1]
            ))
          : result;
      return result;
    },
    handleClick(tab, event) {
        console.log(tab, event);
      },
    ...mapMutations({
      setOrder: "SET_ORDER",
      setDetail: "SET_DETAIL"
    }),
    async getOrders() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.state.lang,
        Usuario: this.$store.state.user.idClienteSAP,
        Estado: 0,
      };

      await this.$http.post(route("Pedidos/listaPedidosWebWithProductoCliente"), params).then(
        (response) => {
          if (response.body.code === 200) {
            console.log("Pedidos:");
            console.log(response.body.pedidos);
            this.pedidos = response.body.pedidos;
          } else {
            console.log(response.body);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
      /*await this.$http.post(route("Pedidos/listaMisPedidosWeb"), params).then(
        (response) => {
          if (response.body.code === 200) {
            console.log("Pedidos:");
            console.log(response.body.lista);
            this.pedidos = response.body.lista;
          } else {
            console.log(response.body);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );*/
    },


  }
};
</script>

<style scoped>
</style>
